import axios from '_u/axios'
import config from '@/config'
import { downLoadBlob } from '_u/helper'

// 用于接受流
const blob = axios.create({
    responseType: 'blob'
})

// 文件上传
export const fileUpload = (formData) => {
    // files    文件数据
    
    return axios.post(config.uploadUrl, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

// 文件下载
export const fileDownload = (id, fileName) => {
    blob.get('api/sys/oss/download', {
            params: {
                id
            }
        })
        .then(blob => downLoadBlob(blob, fileName))
}

// 文件删除
export const fileDelete = (id) => {
    return axios.post('api/sys/oss/delete', {
        id
    })
}

// 文件查询
export const fileList = (pageNo, pageSize, dataId) => {
    var body = {
        page: pageNo,
        limit: pageSize,
        dataId,
    }

    return axios.post('api/sys/oss/list', body)
}

// Zip文件下载
export const fileZip = (ids, fileName) => {
    blob.get('api/sys/oss/zip', {
            params: {
                ids
            }
        })
        .then(blob => downLoadBlob(blob, fileName))
}

// 新增文件存储表
export const fileAdd = (body) => {
    return axios.post('api/sys/oss/add', body)
}

// 更新文件信息
export const fileUpdate = (body) => {
    return axios.post('api/sys/oss/update', body)
}

// 查询文件信息
export const queryBySource = (body) => {
    return axios.post('api/sys/oss/queryBySource', body)
}

// 查询文件外部地址
export const filePath = (id) => {
    return axios.post('api/sys/oss/path', { id })
}